import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import CarouselArrowLight from "../../../assets/images/carousel_arrow_light.svg";
import CarouselArrowDark from "../../../assets/images/carousel_arrow_dark.svg";
import {
  CAROUSEL_DIRECTION_TYPES,
  CAROUSEL_VARIANT,
} from "../../../constants/calculators";
import PropTypes from "prop-types";
import "./carousel.scss";

const SCROLL_OFFSET = 400;

const ScrollAction = ({
  direction,
  visibility,
  onScrollActionClick,
  variant,
}) => {
  return (
    <div
      className={`action-wrapper ${direction} ${
        visibility ? "hide" : ""
      }  ${
        variant === CAROUSEL_VARIANT.DARK ? "dark" : "light"
      }`}
    >
      <img
        src={
          variant === CAROUSEL_VARIANT.DARK
            ? CarouselArrowLight
            : CarouselArrowDark
        }
        className="carousel-action"
        onClick={onScrollActionClick(direction)}
      />
    </div>
  );
};

const CarouselItems = ({ data, handleOnClick }) => {
  return data?.map(item => {
    return (
      <div
        key={item?.title}
        className={`chips-row ${
          item?.selected ? "selected" : ""
        }`}
        onClick={() => {
          handleOnClick(item?.href, item?.title);
        }}
      >
        {item?.title}
      </div>
    );
  });
};

const Carousel = ({
  data,
  handleOnClick,
  variant = CAROUSEL_VARIANT.DARK,
}) => {
  const leftEndRef = useRef();
  const rightEndRef = useRef();

  const onScrollActionClick = useCallback(
    direction => () => {
      let scrollX = SCROLL_OFFSET;
      if (direction === "left")
        scrollX = SCROLL_OFFSET * -1;

      document
        .getElementsByClassName("chips-inner-reel")?.[0]
        ?.scrollBy({
          left: scrollX,
          behavior: "smooth",
        });
    },
    []
  );

  const [
    leftScrollerVisibility,
    setLeftScrollerVisibility,
  ] = useState(false);
  const [
    rightScrollerVisibility,
    setRightScrollerVisibility,
  ] = useState(true);

  useEffect(() => {
    const { current: refForLeftEndValue } = leftEndRef;
    const { current: refForRightEndValue } = rightEndRef;
    if (!refForLeftEndValue || !refForRightEndValue) {
      return;
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === refForRightEndValue) {
          setRightScrollerVisibility(!entry.isIntersecting);
        } else if (entry.target === refForLeftEndValue) {
          setLeftScrollerVisibility(!entry.isIntersecting);
        }
      });
    });

    observer.observe(refForLeftEndValue);
    observer.observe(refForRightEndValue);

    return () => {
      observer.unobserve(refForLeftEndValue);
      observer.unobserve(refForRightEndValue);
    };
  }, []);

  return (
    <div className="carousel-container">
      <ScrollAction
        direction={CAROUSEL_DIRECTION_TYPES.LEFT}
        visibility={!leftScrollerVisibility}
        onScrollActionClick={onScrollActionClick}
        variant={variant}
      />
      <div className="chips-inner-reel">
        <div ref={leftEndRef}></div>
        <div className="chips-rows-wrapper">
          <CarouselItems
            data={data}
            handleOnClick={handleOnClick}
          />
        </div>
        <div ref={rightEndRef}></div>
      </div>
      <ScrollAction
        direction={CAROUSEL_DIRECTION_TYPES.RIGHT}
        visibility={!rightScrollerVisibility}
        onScrollActionClick={onScrollActionClick}
        variant={variant}
      />
    </div>
  );
};

Carousel.propTypes = {
  data: PropTypes.array,
  handleOnClick: PropTypes.func,
};

export default Carousel;
